import Vue from 'vue'
import App from './App.vue'
import store from '@/store'
import { router } from '@/plugins/router/gxqgouche2212'
import '@/utils/axios'
import '@/utils/lodash'
import '@/assets/css/common.styl'
import '@/utils/js-md5'
import { Toast, Dialog, Field, Uploader, Empty, Icon, List, Picker, ActionSheet, Popup, DatetimePicker, Search, Overlay, Image, ImagePreview } from 'vant'
// import { getWxSign } from '@/service/gouche2212/index'
// 引入自定义工具库
import { is_weixin, desensitization } from '@/utils/tools'
// import { initWX } from '@/utils/wxsdk.js'
// 全局方法挂载
Vue.prototype.is_weixin = is_weixin
Vue.prototype.desensitization = desensitization

Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Field)
Vue.use(Uploader)
Vue.use(Empty)
Vue.use(Icon)
Vue.use(List)
Vue.use(Picker)
Vue.use(ActionSheet)
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Search)
Vue.use(Overlay)
Vue.use(Image)
Vue.use(ImagePreview)

// 动态设置title
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // // 只有首页 进行签名
  // if (to.path == '/home') {
  //   const para = {
  //     url: strToHexCharCode(location.href)
  //   }
  //   getWxSign(para).then((res) => {
  //     console.log(res, '签名')
  //     if (res.code == 0) {
  //       let data = res.data
  //       const param = {
  //         appid: data.appid,
  //         timestamp: data.timestamp,
  //         nonceStr: data.nonce,
  //         signature: data.signature
  //       }
  //       setTimeout(() => {
  //         initWX(param)
  //       }, 10)
  //     }
  //   })
  // }
  next()
})

Vue.config.productionTip = false
new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')
